import getAccountSourceListStore from "../store/accountSourceListStore";
import type { AccountSourceType } from "owa-account-source-list-types";

export default function getAccountNumberByType(accountType: AccountSourceType): number {
    return getAccountSourceListStore().sources.filter(accountSource => accountSource.sourceType === accountType).length;
}
